export default {
  // Pages d'authentification
  auth: {
    // Libellés auth communs (utilisés dans les formulaires)
    nameLabel: 'Nom',
    emailLabel: 'Adresse email',
    passwordLabel: 'Mot de passe',
    confirmPasswordLabel: 'Confirmer le mot de passe',
    namePlaceholder: 'Nom complet',
    emailPlaceholder: 'email@exemple.com',
    passwordPlaceholder: 'Mot de passe',
    failed: 'Ces identifiants ne correspondent pas à nos enregistrements.',
    throttle: 'Trop de tentatives de connexion. Veuillez réessayer dans :seconds secondes.',
    login: {
      title: 'Connectez-vous à votre compte',
      description: 'Entrez votre email et mot de passe ci-dessous pour vous connecter',
      pageTitle: 'Connexion',
      emailLabel: 'Adresse email',
      emailPlaceholder: "email{'@'}exemple.com",
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      rememberMe: 'Se souvenir de moi',
      loginButton: 'Se connecter',
      noAccount: "Vous n'avez pas de compte ?",
      signUp: "S'inscrire"
    },
    register: {
      title: 'Créer un compte',
      description: 'Entrez vos informations ci-dessous pour créer votre compte',
      pageTitle: 'Inscription',
      nameLabel: 'Nom',
      namePlaceholder: 'Nom complet',
      emailLabel: 'Adresse email',
      emailPlaceholder: "email{'@'}exemple.com",
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: 'Mot de passe',
      confirmPasswordLabel: 'Confirmer le mot de passe',
      confirmPasswordPlaceholder: 'Confirmer le mot de passe',
      createButton: 'Créer un compte',
      alreadyHaveAccount: 'Vous avez déjà un compte ?',
      login: 'Se connecter'
    },
    forgotPassword: {
      title: 'Mot de passe oublié',
      description: 'Entrez votre adresse email pour recevoir un lien de réinitialisation',
      pageTitle: 'Mot de passe oublié',
      emailLabel: 'Adresse email',
      emailPlaceholder: "email{'@'}exemple.com",
      sendButton: 'Envoyer le lien de réinitialisation',
      backToLogin: 'Ou retourner à',
      backToLoginLink: 'la connexion'
    },
    resetPassword: {
      title: 'Réinitialiser le mot de passe',
      description: 'Entrez votre nouveau mot de passe',
      pageTitle: 'Réinitialiser le mot de passe',
      emailLabel: 'Adresse email',
      passwordLabel: 'Nouveau mot de passe',
      confirmPasswordLabel: 'Confirmer le nouveau mot de passe',
      resetButton: 'Réinitialiser le mot de passe'
    },
    confirmPassword: {
      title: 'Confirmer le mot de passe',
      description: 'Il s\'agit d\'une zone sécurisée de l\'application. Veuillez confirmer votre mot de passe avant de continuer.',
      pageTitle: 'Confirmer le mot de passe',
      passwordLabel: 'Mot de passe',
      confirmButton: 'Confirmer le mot de passe'
    },
    verifyEmail: {
      title: 'Vérification de l\'adresse email',
      description: 'Avant de continuer, veuillez vérifier votre adresse email en cliquant sur le lien que nous venons de vous envoyer.',
      pageTitle: 'Vérifier votre email',
      resendButton: 'Renvoyer le lien de vérification',
      logoutButton: 'Se déconnecter'
    }
  },

  // Navigation et menus
  navigation: {
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    logout: 'Se déconnecter',
    navigationMenu: 'Menu de navigation',
    platform: 'Plateforme',
    administration: 'Administration',
    // Traductions pour usage futur dans d'autres branches
    repository: 'Dépôt',
    documentation: 'Documentation',
    githubRepo: 'Dépôt GitHub',
    externalLink: 'Lien externe'
  },

  // Dashboard
  dashboard: {
    title: 'Tableau de bord',
    pageTitle: 'Tableau de bord',
    welcome: 'Bienvenue',
    admin_overview: 'Vue d\'ensemble administrateur de votre application',
    user_overview: 'Votre espace personnel et activités',
    admin_mode: 'Mode Administrateur',
    user_mode: 'Mode Utilisateur',
    stats: {
      total_users: 'Utilisateurs totaux',
      total_users_desc: 'Nombre total d\'utilisateurs inscrits',
      active_users: 'Utilisateurs actifs',
      active_users_desc: 'Utilisateurs connectés ce mois',
      pending_tasks: 'Tâches en attente',
      pending_tasks_desc: 'Tâches à traiter',
      growth_rate: 'Taux de croissance',
      growth_rate_desc: 'Croissance ce mois'
    },
    user_stats: {
      profile_completion: 'Profil complété',
      profile_completion_desc: 'Pourcentage de votre profil rempli',
      notifications: 'Notifications',
      notifications_desc: 'Notifications non lues',
      recent_activity: 'Activité récente',
      recent_activity_desc: 'Actions effectuées ce mois',
      tasks_completed: 'Tâches terminées',
      tasks_completed_desc: 'Tâches accomplies cette semaine'
    },
    recent_activity: 'Activité récente',
    my_activity: 'Mon activité',
    user_logged_in: 'Utilisateur connecté',
    new_user_registered: 'Nouvel utilisateur inscrit',
    task_completed: 'Tâche terminée',
    profile_updated: 'Profil mis à jour',
    password_changed: 'Mot de passe modifié',
    account_created: 'Compte créé',
    quick_actions: 'Actions rapides',
    admin_actions: 'Actions administrateur',
    manage_users: 'Gérer les utilisateurs',
    view_analytics: 'Voir les analyses',
    system_settings: 'Paramètres système',
    complete_profile: 'Compléter le profil',
    account_settings: 'Paramètres du compte',
    notification_preferences: 'Préférences notifications',
    getting_started: 'Pour bien commencer',
    getting_started_desc: 'Complétez votre profil et explorez les fonctionnalités disponibles.',
    explore_features: 'Explorer les fonctionnalités',
    user_welcome_message: 'Vous êtes connecté avec succès. Explorez les fonctionnalités disponibles.',
    get_started: 'Commencer'
  },



  // Paramètres
  settings: {
    title: 'Paramètres',
    description: 'Gérez votre profil et les paramètres de votre compte',
    navigation: {
      profile: 'Profil',
      password: 'Mot de passe',
      appearance: 'Apparence'
    },
    profile: {
      title: 'Profil',
      pageTitle: 'Paramètres de profil',
      breadcrumbTitle: 'Paramètres de profil',
      description: 'Mettez à jour votre nom et votre adresse email',
      nameLabel: 'Nom',
      namePlaceholder: 'Nom complet',
      emailLabel: 'Adresse email',
      emailPlaceholder: 'Adresse email',
      saveButton: 'Enregistrer',
      saved: 'Enregistré.',
      emailUnverified: 'Votre adresse email n\'est pas vérifiée.',
      resendVerification: 'Cliquez ici pour renvoyer l\'email de vérification.',
      deleteAccount: 'Supprimer le compte',
      deleteAccountDescription: 'Supprimer votre compte et toutes ses ressources'
    },
    password: {
      title: 'Mettre à jour le mot de passe',
      pageTitle: 'Changer le mot de passe',
      breadcrumbTitle: 'Paramètres de mot de passe',
      currentPasswordLabel: 'Mot de passe actuel',
      newPasswordLabel: 'Nouveau mot de passe',
      confirmPasswordLabel: 'Confirmer le nouveau mot de passe',
      updateButton: 'Mettre à jour le mot de passe',
      description: 'Assurez-vous que votre compte utilise un mot de passe long et aléatoire pour rester sécurisé.',
      saved: 'Enregistré.'
    },
    appearance: {
      title: 'Paramètres d\'apparence',
      pageTitle: 'Apparence',
      breadcrumbTitle: 'Paramètres d\'apparence',
      description: 'Mettez à jour les paramètres d\'apparence de votre compte',
      themeLabel: 'Thème',
      lightTheme: 'Clair',
      darkTheme: 'Sombre',
      systemTheme: 'Système',
      forcedThemeDescription: 'L\'application utilise exclusivement le thème sombre avec une palette de couleurs verte.'
    },
    deleteUser: {
      title: 'Supprimer le compte',
      description: 'Supprimer votre compte et toutes ses ressources',
      warning: 'Attention',
      warningDescription: 'Veuillez procéder avec prudence, cette action ne peut pas être annulée.',
      deleteButton: 'Supprimer le compte',
      confirmTitle: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
      confirmDescription: 'Une fois votre compte supprimé, toutes ses ressources et données seront également supprimées définitivement. Veuillez entrer votre mot de passe pour confirmer que vous souhaitez supprimer définitivement votre compte.',
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: 'Mot de passe',
      cancel: 'Annuler'
    }
  },

  // Messages généraux
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    view: 'Voir',
    create: 'Créer',
    status: 'Statut',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    close: 'Fermer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    saving: 'Enregistrement...',
    creating: 'Création...',
    updating: 'Mise à jour...',
    active: 'Actif',
    inactive: 'Inactif',
    optional: 'Optionnel',
    required: 'Requis',
    information: 'Informations',
    search: 'Rechercher',
    filters: 'Filtres',
    reset: 'Réinitialiser',
    actions: 'Actions',
    refresh: 'Actualiser',
    permission_denied: 'Vous n\'avez pas les permissions nécessaires',
    time: {
      now: 'À l\'instant',
      minutes_ago: 'Il y a {count} min',
      hours_ago: 'Il y a {count}h',
      days_ago: 'Il y a {count}j'
    }
  },

  // Langues
  language: {
    french: 'Français',
    english: 'English',
    selectLanguage: 'Changer de langue'
  },

  // Administration
  admin: {
    users: {
      title: 'Gestion des utilisateurs',
      description: 'Gérer les utilisateurs et leurs rôles',
      add_user: 'Ajouter un utilisateur',
      user_list: 'Liste des utilisateurs',
      total_users: 'Total utilisateurs',
      verified_users: 'Utilisateurs vérifiés',
      unverified_users: 'Non vérifiés',
      admin_users: 'Administrateurs',
      search_placeholder: 'Rechercher par nom ou email...',
      filter_by_role: 'Filtrer par rôle',
      all_roles: 'Tous les rôles',
      all_statuses: 'Tous les statuts',
      verified: 'Vérifiés',
      unverified: 'Non vérifiés',
      email_not_verified: 'Email non vérifié',
      resend_verification: 'Renvoyer vérification',
      showing_users: 'Affichage de {from} à {to} sur {total} utilisateurs',
      confirm_delete: 'Êtes-vous sûr de vouloir supprimer {name} ?',
      user_info: 'Informations utilisateur',
      email_verified: 'Email vérifié',
      created_at: 'Créé le',
      roles_permissions: 'Rôles et permissions',
      roles_permissions_desc: 'Rôles et permissions assignés à cet utilisateur',
      roles: 'Rôles',
      permissions: 'Permissions',
      create_description: 'Créer un nouvel utilisateur avec ses informations et son rôle',
      edit_description: 'Modifier les informations de l\'utilisateur et son rôle',
      user_details: 'Détails de l\'utilisateur',
      role: 'Rôle',
      select_role: 'Sélectionner un rôle',
      create_user: 'Créer l\'utilisateur',
      edit_user: 'Modifier l\'utilisateur',
      edit_details: 'Modifier les informations',
      new_password: 'Nouveau mot de passe',
      new_password_placeholder: 'Laisser vide pour ne pas changer',
      password_optional: 'Laisser vide pour conserver le mot de passe actuel',
      edit_save_info: 'Après sauvegarde, vous serez redirigé vers la liste des utilisateurs',
      notifications: 'Notifications',
      receive_contact_notifications: 'Recevoir les demandes de contact',
      receive_contact_notifications_description: 'Cet utilisateur recevra un email à chaque nouvelle demande de contact soumise sur le site.',
    },
    roles: {
      'super-admin': 'Super Admin',
      'admin': 'Administrateur',
      'user': 'Utilisateur',
      'prestataire': 'Prestataire'
    }
  },

  // Messages de notification
  notifications: {
    profileUpdated: 'Profil mis à jour avec succès.',
    passwordUpdated: 'Mot de passe mis à jour avec succès.',
    emailVerificationSent: 'Un nouveau lien de vérification a été envoyé à votre adresse email.',
    accountDeleted: 'Votre compte a été supprimé.'
  },

  // Validation
  validation: {
    phone_number: 'Le numéro de téléphone n\'est pas valide',
    postal_code: 'Le code postal n\'est pas valide',
    file_type: 'Le type de fichier n\'est pas autorisé',
    file_size: 'Le fichier est trop volumineux (max {max}MB)',
    max_files: 'Trop de fichiers sélectionnés (max {max})'
  },

  // Upload de fichiers
  upload: {
    click_to_upload: 'Cliquer pour télécharger',
    or_drag_and_drop: 'ou glisser-déposer',
    max_size: 'Taille max: {size}',
    file_selected: '{count} fichier(s) sélectionné(s)',
    remove_file: 'Supprimer le fichier'
  },

  // Système de notifications
  notificationSystem: {
    title: 'Notifications',
    no_notifications: 'Aucune notification',
    mark_as_read: 'Marquer comme lu',
    mark_all_read: 'Tout marquer comme lu',
    view_all: 'Voir toutes les notifications',
    welcome: {
      subject: 'Bienvenue !',
      title: 'Bienvenue',
      greeting: 'Bonjour {name} !',
      message: 'Bienvenue {name} !',
      line1: 'Merci de vous être inscrit(e) sur notre plateforme.',
      line2: 'Vous pouvez maintenant accéder à toutes les fonctionnalités.',
      action: 'Accéder au tableau de bord',
      footer: 'Merci d\'utiliser notre application !'
    }
  },

  // Événements
  events: {
    title: 'Événements',
    our_events: 'Nos Événements',
    event: 'Événement',
    description: 'Découvrez tous les événements à venir',
    no_events: 'Aucun événement trouvé',
    no_events_message: 'Aucun événement ne correspond à votre recherche.',
    no_events_scheduled: 'Aucun événement prévu pour le moment.',
    search_placeholder: 'Rechercher un événement...',
    reset_search: 'Réinitialiser la recherche',
    view_details: 'Voir les détails',
    other_events: 'Autres événements',
    discover_next: 'Découvrez nos prochains rendez-vous',
    see_all_events: 'Voir tous les événements',
    share_event: 'Partager l\'événement',
    back_to_events: 'Retour aux événements',
    home: 'Accueil',
    my_account: 'Mon compte',
    event_count: '{count} événement{plural}',
    status: {
      active: 'Événement actif',
      inactive: 'Inactif',
      past: 'Terminé',
      cancelled: 'Annulé'
    },
    info: {
      practical_info: 'Informations pratiques',
      schedule: 'Horaires',
      start: 'Début',
      end: 'Fin',
      location: 'Lieu',
      organized_by: 'Organisé par',
      team: 'Équipe Lyra Events',
      date: 'Date',
      time: 'Heure',
      need_info: 'Besoin d\'informations ?'
    },
    admin: {
      management: 'Gestion des Événements',
      management_description: 'Gérez tous les événements du bar',
      create: 'Créer un Événement',
      create_description: 'Ajoutez un nouvel événement au bar',
      edit: 'Modifier l\'Événement',
      edit_description: 'Modifiez les informations de l\'événement',
      new_event: 'Nouvel Événement',
      back_to_list: 'Retour à la liste',
      view_event: 'Voir l\'événement',
      total_events: 'Total événements',
      active_events: 'Événements actifs',
      upcoming: 'À venir',
      past: 'Terminés',
      form: {
        title: 'Titre de l\'événement',
        title_placeholder: 'Ex: Soirée Jazz Live',
        description: 'Description',
        description_placeholder: 'Décrivez votre événement...',
        start_date: 'Date et heure de début',
        end_date: 'Date et heure de fin',
        location: 'Lieu',
        location_placeholder: 'Ex: Salle principale, Bar, Terrasse...',
        image_url: 'Image',
        image_placeholder: 'https://exemple.com/image.jpg',
        is_active: 'Événement actif (visible sur le site public)',
        preview: 'Aperçu',
        event_info: 'Informations de l\'événement',
        created_by: 'Créé par',
        created_at: 'Créé le',
        updated_at: 'Modifié le',
        current_status: 'Statut actuel'
      },
      actions: {
        create: 'Créer l\'événement',
        creating: 'Création...',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        draft: 'Enreg. brouillon',
        deactivate: 'Désactiver',
        deactivating: 'Désactivation...',
        delete: 'Supprimer cet événement',
        confirm_delete: 'Êtes-vous sûr de vouloir supprimer définitivement l\'événement "{title}" ?',
        delete_error: 'Une erreur est survenue lors de la suppression.'
      }
    },
    cta: {
      join_community: 'Rejoignez notre communauté',
      join_description: 'Créez votre compte fidélité et profitez d\'avantages exclusifs',
      register_free: 'S\'inscrire gratuitement',
      login: 'Se connecter'
    },
    messages: {
      link_copied: 'Lien copié dans le presse-papiers !'
    }
  },

  // Promotions
  promotions: {
    title: 'Mes Promotions',
    description: 'Profitez de vos avantages fidélité exclusifs',
    available: 'Promotions disponibles',
    used: 'Promotions utilisées',
    no_promotions: 'Aucune promotion disponible',
    no_promotions_message: 'Revenez bientôt pour découvrir de nouvelles offres exclusives !',
    no_used_promotions: 'Aucune promotion utilisée',
    no_used_promotions_message: 'Vos promotions utilisées apparaîtront ici.',
    history: 'Historique des promotions',
    ready_to_use: 'Prêtes à être utilisées',
    usage_history: 'Historique d\'utilisation',
    promotion_count: '{count} promotion{plural}',
    promotion_used_count: '{count} promotion{plural} utilisée{plural}',
    valid_until: 'Valide jusqu\'au',
    usage_limit: 'Max {limit} utilisation{plural} par personne',
    use_now: 'Utiliser maintenant',
    using: 'Utilisation...',
    used_label: 'Utilisée',
    used_on: 'Utilisée le',
    confirm_use: 'Êtes-vous sûr de vouloir utiliser la promotion "{title}" ?',
    use_error: 'Une erreur est survenue lors de l\'utilisation de la promotion.',
    errors: {
      already_used: 'Vous avez déjà utilisé cette promotion.',
      usage_limit_reached: 'Vous avez atteint la limite d\'utilisation de cette promotion.',
      not_active: 'Cette promotion n\'est plus active.',
      expired: 'Cette promotion a expiré.',
      not_available_yet: 'Cette promotion n\'est pas encore disponible.',
      unknown: 'Une erreur est survenue lors de l\'utilisation de la promotion.'
    },
    how_it_works: {
      title: 'Comment ça marche ?',
      description: 'Profitez simplement de vos avantages fidélité',
      step1_title: 'Consultez vos promotions',
      step1_description: 'Découvrez toutes vos offres exclusives disponibles',
      step2_title: 'Utilisez en un clic',
      step2_description: 'Activez votre promotion directement depuis votre compte',
      step3_title: 'Profitez au bar',
      step3_description: 'Présentez votre confirmation à notre équipe'
    },
    admin: {
      management: 'Gestion des Promotions',
      management_description: 'Gérez les promotions du programme fidélité',
      create: 'Créer une Promotion',
      edit: 'Modifier la Promotion',
      new_promotion: 'Nouvelle Promotion',
      new_promotion_description: 'Ajoutez une nouvelle promotion au programme fidélité',
      edit_description: 'Modifiez les informations de la promotion',
      back_to_list: 'Retour à la liste',
      view_promotion: 'Voir la promotion',
      total_promotions: 'Total promotions',
      active_promotions: 'Promotions actives',
      total_usages: 'Total utilisations',
      expired_promotions: 'Promotions expirées',
      save_draft: 'Enreg. brouillon',
      create_promotion: 'Créer la promotion',
      update_promotion: 'Modifier la promotion',
      form: {
        title: 'Titre de la promotion',
        title_placeholder: 'Ex: Happy Hour - 20% de réduction',
        description: 'Description',
        description_placeholder: 'Décrivez votre promotion en détail...',
        type: 'Type de promotion',
        select_type: 'Sélectionnez un type',
        percentage_value: 'Pourcentage de réduction',
        amount_value: 'Montant de réduction (€)',
        valid_from: 'Date de début',
        valid_until: 'Date de fin',
        usage_limit: 'Limite d\'utilisation par utilisateur',
        usage_limit_placeholder: 'Laissez vide pour aucune limite',
        usage_limit_help: 'Nombre maximum d\'utilisations par utilisateur (optionnel)',
        image_url: 'Image',
        conditions: 'Conditions d\'utilisation',
        conditions_placeholder: 'Ex: Valable uniquement les weekends, Commande minimum 25€...',
        is_active: 'Promotion active (visible et utilisable par les clients)',
        preview: 'Aperçu'
      }
    },
    types: {
      percentage: 'Pourcentage de réduction',
      fixed_amount: 'Montant fixe de réduction',
      free_drink: 'Boisson offerte'
    }
  },

  // Prestations
  prestations: {
    title: 'Prestations',
    newDemand: 'Nouvelle demande',
    respond: 'Répondre',
    available: 'Disponible',
    unavailable: 'Pas disponible',
    assigned: 'Attribuée',
    history: 'Historique',
    status: {
      draft: 'Brouillon',
      published: 'Publiée',
      assigned: 'Attribuée',
      completed: 'Terminée',
      cancelled: 'Annulée'
    },
    response: {
      pending: 'En attente',
      available: 'Disponible',
      unavailable: 'Indisponible',
      assigned: 'Retenu',
      rejected: 'Non retenu'
    }
  }


};
